<template>
    <Cta
        :type="currentComponent"
        :to="$trl(currentRoute)"
        :colors="colors"
        class="link"
        :href="currentHref"
        :target="target"
    >{{cta.caption}}</Cta>
</template>

<script>
import Cta from '@/components/Cta'
const routes = {
    project: 'Project',
    market: 'Market',
    technique: 'Technique',
    story: 'Story'
}
export default {
    components: {
        Cta
    },
    props: {
        colors: {
            type: Object,
            default() {}
        },
        cta: {
            type: Object,
            default() {}
        }
    },
    computed: {
        currentComponent() {
            return this.cta.type === 'object' || this.cta.type === 'link' ? 'router-link' : 'a'
        },
        currentRoute() {
            if(this.cta.type === 'object') {
                if(this.post.object.post_type === "custom-page") {
                    return {
                        name: this.post.object.post_name,
                        params: {
                            locale: this.$route.params.locale
                        }
                    }
                } else {
                    const technique = this.cta.object.related_posts.find(_ => _.type === 'technique')

                    return {
                        name: routes[this.cta.object.post_type],
                        params: {
                            slug: this.cta.object.post_name,
                            locale: this.$route.params.locale,
                            technique: technique ? technique.customslug || technique.slug : ''
                        }
                    }
                }
            } else if(this.cta.type === 'link') {
                return {
                    name: this.cta.link,
                    params: {
                        locale: this.$route.params.locale
                    }
                }
            } else {
                return {}
            }
        },
        currentHref() {
            if(this.cta.type === 'object' || this.cta.type === 'link') {
                return null
            } else if(this.cta.type === 'url'){
                return this.cta.url
            } else if(this.cta.type === 'download'){
                return this.cta.file
            }
            return new Error('post type must be "object", "url" or "download"')
        },
        target() {
            if(this.cta.type === 'object' || this.cta.type === 'link') {
                return '_self'
            } else {
                return '_blank'
            }

        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.decoration
    margin-top: -15%
    img
        display: block
        width: 100%
        margin-left: auto

.gabarit
    position: relative
    z-index: 1
    color: #ffffff
    display: flex
.sizer
    flex: 1
    width: 50%
    background-color: #ff2b2a
    overflow: hidden
    position: relative
    padding-top: 8.125%
    padding-bottom: 10%
.head
    flex: 1
    width: 50%
    overflow: hidden
    padding-top: 8.125%
.container
    padding-left: 28%
    padding-right: 24%
    &+.container
        padding-top: 8.125%

.head-sizer
    padding-left: 17.25%
    box-sizing: content-box
    width: 100%
    &.dark
        position: absolute
        left: -100%
        h2
            color: #ffffff
h2
    font-size: 160px
    font-weight: 500
    color: #ff2b2a
    white-space: nowrap
    letter-spacing: -0.03125em
p
    font-size: 28px
    line-height: 1.6071428571
    margin-top: 1em
.cta
    margin-top: 12%
</style>
